import React from 'react';
import { cn } from '../../lib/utils';

/**
 * PageContainer — wraps page content with consistent max-width + spacing.
 * Used inside <Layout> to give every page the same rhythm.
 */
const PageContainer = ({ className = '', children, wide = false }) => (
  <div
    className={cn(
      'w-full mx-auto px-0',
      wide ? 'max-w-[1600px]' : 'max-w-[1400px]',
      className,
    )}
  >
    {children}
  </div>
);

export default PageContainer;
